import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './crowdfunding_campaign_header.less'
import {
  Col,
  Icon,
  Row,
  HeadingText,
  CaptionText,
  Avatar,
} from '@paypalcorp/pp-react'

class CrowdFundingCampaignHeader extends React.Component {
  static propTypes = {
    poolName: PropTypes.string.isRequired,
    categoryName: PropTypes.string.isRequired,
    creatorName: PropTypes.string.isRequired,
    profileImage: PropTypes.string.isRequired,
    initials: PropTypes.string.isRequired,
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Col>
            <HeadingText size="lg">{this.props.poolName}</HeadingText>
          </Col>
        </Row>
        <Row styleName="iconCaptionRow">
          <Col lg="auto" md="auto" xs="auto" styleName="iconCaptionContainer">
            <Avatar
              src={this.props.profileImage}
              initials={this.props.initials}
              size="xs"
            />
            <CaptionText styleName="headerCaptionText" size="sm">
              {this.props.creatorName}
            </CaptionText>
          </Col>
          <Col lg="auto" md="auto" xs="auto" styleName="iconCaptionContainer">
            <Icon name="activity" size="xs" />
            <CaptionText styleName="headerCaptionText" size="sm">
              {this.props.categoryName}
            </CaptionText>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

export default cssModules(CrowdFundingCampaignHeader, styles, {
  allowMultiple: true,
})
